import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import NoItems from '../../Components/EmptyStates/NoItems';
import { useNavigate } from 'react-router-dom';
import { useSession } from '../../Components/Session';
import { useDialogues } from '../../Components/Dialogues';

const Setup = () => {
    const navigate = useNavigate();
    const {hasFeature} = useSession();
    const {featureUnavailable} = useDialogues();

    return <>
        <TopBar title="Payments" />
        <Page>
            <NoItems
                icon="BuildingColumns"
                title="Setup payments"
                message={<>
                    Automatically charge your customers using credit cards or direct debit.
                </>}
                onClick={() => hasFeature('CARDS_PAYMENTS') ? navigate('/settings/payments/setup') : featureUnavailable('BANK_RECONCILIATION')}
            />
        </Page>
    </>
}

export default Setup;
